import { Users } from "lucide-react";
import type { EventStats, Locale } from "@vzlive/shared";
import { t } from "@vzlive/shared/i18n";

export function LiveStats({
  stats,
  locale,
}: {
  stats: EventStats;
  locale: Locale;
}) {
  const values = stats.points.slice(-30);
  const max = Math.max(1, ...values.map((point) => point.peakOnline));
  const points = values
    .map((point, index) => {
      const x = values.length === 1 ? 100 : (index / (values.length - 1)) * 100;
      const y = 34 - (point.peakOnline / max) * 30;
      return `${x},${y}`;
    })
    .join(" ");

  return (
    <aside className="reader-stats">
      <div>
        <Users size={17} />
        <strong>{stats.onlineNow}</strong> {t(locale, "online")}
      </div>
      {values.length > 1 && (
        <svg viewBox="0 0 100 36" preserveAspectRatio="none" aria-hidden="true">
          <polyline points={points} />
        </svg>
      )}
    </aside>
  );
}
